import React, { useEffect, useState } from 'react';
import Checkbox from "../../components/checkbox";

/* import from view folder */
import Lists from "../../assecs/json/select/device.json";

const Columnbox = ({ defaultValue = [], changeHandle }) => {
    const [selected, setSelected] = useState(defaultValue);

    const changeHandler = ({ target: { checked, value } }) => {
        const _selected = [...selected];

        if (checked) _selected.push(value);
        else {
            const index = _selected.indexOf(value);

            if (index > -1) _selected.splice(index, 1);
        }

        setSelected(_selected);
    };

    useEffect(() => {
        const _selected = [...selected].join(',');
        
        changeHandle({ target: { name: 'columns', value: _selected } });
    }, [ selected ]);

    return (
        <div className='column-box'>
            {
                Lists.column.map(({ key, value }) => 
                    <Checkbox key={ key } status={ selected.includes(key) } checkId={ key } title={ value } changeHandle={ changeHandler } />
                )
            }
        </div>
    )
};

export default React.memo(Columnbox);